import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CoursesBanner from "../../../components/freelancer/courses/CoursesBanner";
import CoursesBoxes from "../../../components/freelancer/courses/CoursesBoxes";
import { axiosInstance } from "../../../config/https";
import { useLoader, useModal } from "../../../context/LoaderContext";

function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const [filterCourses, setFilterCourses] = useState([]);
  const { startLoader, stopLoader } = useLoader();
  const { openModal } = useModal();
  useEffect(() => {
    getCourses();

    openModal(
      "course-earn", //gif url
      "Skill Up & Connect Up!", //title
      "Embark on a learning journey! Join a course now and earn free coins along the way – empowering your growth and success in freelancing." //subtitle
    );
  }, []);

  const getCourses = () => {
    startLoader(true);
    axiosInstance.get("/api/courses/").then((resp) => {
      stopLoader(false);
      const Data = resp.data;
      if (resp.status === 200 || resp.status === 201) {
        setCourses(Data);
        setFilterCourses(Data);
      } else {
        toast.warning(Data.msg);
      }
    });
  };

  const handleFilterChange = (event) => {
    const value = event.target.value.toLowerCase();
    const filteredData = courses.filter((item) =>
      item.title.toLowerCase().includes(value)
    );
    setFilterCourses(filteredData);
  };

  return (
    <div>
      <CoursesBanner />
      <CoursesBoxes
        courses={filterCourses}
        handleFilterChange={handleFilterChange}
      />
    </div>
  );
}

export default CoursesPage;
